import { GetAllTemplateTasksAPI } from "../../services/api/project-template-api";
import { TemplateTaskActionTypes } from "./template-task-types";

export const fetchTemplateTasks = (searchQuery) => {
  return async (dispatch) => {
    try {
      dispatch(fetchTemplateTasksStart());

      const templateTasks = await GetAllTemplateTasksAPI(
        { ...searchQuery },
        searchQuery.id
      );
      if (
        templateTasks?.response?.status === 200 ||
        templateTasks?.status === 200
      ) {
        let payload = [
          templateTasks.data.dataList,
          templateTasks.data.totalCount,
        ];

        dispatch(fetchTemplateTasksSuccess(payload));
        dispatch(setSearchTemplateTasksQuery(searchQuery));
        dispatch(setTemplateTasksOnPage(templateTasks.data.dataList));
      } else {
        throw new Error(templateTasks?.response?.data);
      }
      return templateTasks.data.dataList;
    } catch (error) {
      dispatch(fetchTemplateTasksFailure());
      console.log(error);
    }
  };
};

export const showTemplateSubtask = (taskId) => {
  return async (dispatch, getState) => {
    const tasks = getState().templateTasks.templateTasks;
    let tasksWithSubtaskOpen = [];

    try {
      tasks.forEach((task) =>
        task.Id === taskId
          ? tasksWithSubtaskOpen.push({
              ...task,
              subtaskOpen: !task.subtaskOpen,
            })
          : tasksWithSubtaskOpen.push(task)
      );
    } catch (error) {
      console.log(error);
    }

    const payload = [tasksWithSubtaskOpen, tasksWithSubtaskOpen.length];
    dispatch(fetchTemplateTasksSuccess(payload));
    dispatch(setTemplateTasksOnPage(tasksWithSubtaskOpen));
  };
};

export const fetchTemplateTasksStart = () => ({
  type: TemplateTaskActionTypes.FETCH_TEMPLATE_TASKS_START,
});

export const fetchTemplateTasksFailure = () => ({
  type: TemplateTaskActionTypes.FETCH_TEMPLATE_TASKS_FAILURE,
});

export const fetchTemplateTasksSuccess = (payload) => ({
  type: TemplateTaskActionTypes.FETCH_TEMPLATE_TASKS_SUCCESS,
  payload: payload,
});

export const setTemplateTasksOnPage = (templateTasksOnPage) => ({
  type: TemplateTaskActionTypes.SET_TEMPLATE_TASKS_ON_PAGE,
  payload: templateTasksOnPage,
});

export const setSearchTemplateTasksQuery = (searchQuery) => ({
  type: TemplateTaskActionTypes.SET_SEARCH_TEMPLATE_TASKS_QUERY,
  payload: searchQuery,
});

export const addSelectedTemplateTasks = (id) => ({
  type: TemplateTaskActionTypes.ADD_SELECTED_TEMPLATE_TASKS,
  payload: id,
});

export const deleteSelectedTemplateTasks = (id) => ({
  type: TemplateTaskActionTypes.DELETE_SELECTED_TEMPLATE_TASKS,
  payload: id,
});

export const setSelectedTemplateTasks = (idList) => ({
  type: TemplateTaskActionTypes.SET_SELECTED_TEMPLATE_TASKS,
  payload: idList,
});
